import React, { useRef, useState } from "react";
import { ReactComponent as ArrowDownIcon } from "assets/icons/arrow-down.svg";
import { ApplicationType, ModuleName, useOutsideClick } from "modules/common";
import { useDispatch, useSelector } from "react-redux";
import { logOff, useIsLocalLoginAllowed, UserSupportModal } from "modules/auth";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "routing";
import { RootState } from "store";
import { ProfileImage } from "./ProfileImage";
import { CreateModuleUsageLogRequest, logOut } from "services";
import { createModuleUsageLogData } from "modules/dashboard/store/moduleActivity";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";
import useEnvironment from "hooks/useLocalhost";
import { useElementRendered } from "helpers/DomHelper";

export const ProfileSettings: React.FC = () => {
    const dispatch = useDispatch();
    const profile = useSelector((state: RootState) => state.profile.profile);
    const signIn = useSelector((state: RootState) => state.signIn);
    const history = useHistory();
    const isLocalLoginAllowed = useIsLocalLoginAllowed();
    const { currentEnv } = useEnvironment();
    const isNiasHeaderShowing = useElementRendered("nav#shell");

    const [isOpen, setIsOpen] = useState(false);
    const [showSupportModal, setShowSupportModal] = useState(false);

    const handleMenuClick = () => {
        setIsOpen(prev => !prev);
    };

    const toggleSupportModal = () => {
        setShowSupportModal(!showSupportModal);
        setIsOpen(false);
    };

    const handleOutsideClick = () => {
        setIsOpen(false);
    };
    const profileSettingsrRef = useRef<HTMLDivElement>(null);

    const handleLogout = () => {
        logOut(signIn.user?.accessToken ?? "");
        dispatch(logOff());
        history.push(AppRoutes.Home);
    };

    const handleOpenProfile = () => {
        setIsOpen(false);
        handleCreateModuleUsageLog();
    };

    const handleCreateModuleUsageLog = () => {
        const createModuleUsageLogRequest: CreateModuleUsageLogRequest = {
            moduleUsageType: ModuleName.UserProfile,
            applicationSourceType: ApplicationType.Web,
        };
        history.push(AppRoutes.Profile);
        dispatch(createModuleUsageLogData(createModuleUsageLogRequest));
    };

    useOutsideClick(profileSettingsrRef, handleOutsideClick);
    return (
        <>
            <div
                ref={profileSettingsrRef}
                onClick={handleMenuClick}
                className="settings-container"
                tabIndex={0}
                onKeyDown={e => handleKeyDown(e, () => setIsOpen(prev => !prev))}
                onBlur={e => {
                    if (!profileSettingsrRef.current?.contains(e.relatedTarget as Node)) {
                        setIsOpen(false);
                    }
                }}
            >
                <ProfileImage />
                <div className="profile-wrapper">
                    <ArrowDownIcon />
                    <ul
                        className={`profile__dropdown profile__items ${
                            isOpen ? "profile__dropdown--active" : ""
                        }`}
                    >
                        <li className="profile__header">
                            <ProfileImage className="mr-8" />
                            <span>
                                {profile?.firstName} {profile?.lastName}
                            </span>
                        </li>
                        <li
                            onClick={handleOpenProfile}
                            className="profile__item"
                            tabIndex={0}
                            onKeyDown={e => handleKeyDown(e, handleOpenProfile)}
                        >
                            Postavke
                        </li>
                        <li
                            onClick={toggleSupportModal}
                            className="profile__item"
                            tabIndex={0}
                            onKeyDown={e => handleKeyDown(e, toggleSupportModal)}
                        >
                            Korisnička podrška
                        </li>
                        {isLocalLoginAllowed.data && !isNiasHeaderShowing && (
                            <li
                                className="profile__item"
                                onClick={handleLogout}
                                tabIndex={0}
                                onKeyDown={e => handleKeyDown(e, handleLogout)}
                            >
                                Odjava
                            </li>
                        )}
                    </ul>
                </div>
            </div>
            <UserSupportModal toggleModal={toggleSupportModal} isVisible={showSupportModal} />
        </>
    );
};
